import * as Yup from 'yup'

const baseObjectiveResultSchema = {
  id: Yup.number().required(),
  startDate: Yup.string().required().label('Start date'),
  endDate: Yup.string().nullable().label('End date'),
  impressions: Yup.number()
    .required()
    .moreThan(-1, 'Please enter a valid value')
    .integer()
    .label('Impressions'),
  campaignClicks: Yup.number()
    .required()
    .moreThan(-1, 'Please enter a valid value')
    .integer()
    .label('Campaign clicks'),
}

export const objectiveResultSchema = Yup.object({
  ...baseObjectiveResultSchema,
  totalImpressions: Yup.number()
    .moreThan(-1, 'Please enter a valid value')
    .integer()
    .label('Total impressions'),
  totalCampaignClicks: Yup.number()
    .moreThan(-1, 'Please enter a valid value')
    .integer()
    .label('Total campaign clicks'),
})

export type ObjectiveResult = Yup.InferType<typeof objectiveResultSchema>

export const createObjectiveResultSchema = objectiveResultSchema.omit(['id'])
export type CreateObjectiveResult = Yup.InferType<typeof createObjectiveResultSchema>

export const objectiveSchema = Yup.object({
  id: Yup.number().integer().required(),
  intents: Yup.number().integer().required(),
  isIntentsEnabled: Yup.boolean().required(),
  isCompaniesDiscoveredEnabled: Yup.boolean().required(),
  isContactsDiscoveredEnabled: Yup.boolean().required(),
  isTelesaleHoursEnabled: Yup.boolean().required(),
  isMeetingBookedEnabled: Yup.boolean().required(),
  isMcoActivitiesEnabled: Yup.boolean().required(),
  isTargetPipelineValueEnabled: Yup.boolean().required(),
  isDealRegDoneEnabled: Yup.boolean().required(),
  isDigitalLeadsEnabled: Yup.boolean().required(),
  isConnectionRequestsSentEnabled: Yup.boolean().required(),
  isConnectionRequestsAcceptedEnabled: Yup.boolean().required(),
  isImpressionsEnabled: Yup.boolean().required(),
  isCampaignClicksEnabled: Yup.boolean().required(),
  companiesDiscovered: Yup.number().integer().required(),
  contactsDiscovered: Yup.number().integer().required(),
  telesaleHours: Yup.number().integer().required(),
  meetingBooked: Yup.number().integer().required(),
  mcoActivities: Yup.number().integer().required(),
  targetPipelineValue: Yup.number().integer().required(),
  dealRegDone: Yup.number().integer().required(),
  digitalLeads: Yup.number().integer().required(),
  connectionRequestsSent: Yup.number().integer().required(),
  connectionRequestsAccepted: Yup.number().integer().required(),
  impressions: Yup.number().integer().required(),
  campaignClicks: Yup.number().integer().required(),
  isDataIntelligenceActive: Yup.boolean().required(),
  isTeleProspectingActive: Yup.boolean().required(),
  isDigitalProspectingActive: Yup.boolean().required(),
  results: Yup.array(objectiveResultSchema),
})
export type Objective = Yup.InferType<typeof objectiveSchema>

export const createObjectiveRequestSchema = objectiveSchema.omit(['id', 'results'])
export type CreateObjectiveRequest = Yup.InferType<typeof createObjectiveRequestSchema>
